import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=396e24f9&"
import script from "../../../public/js/img/Discoveryjs/AutorisationJs/Permission.js?vue&type=script&lang=js&"
export * from "../../../public/js/img/Discoveryjs/AutorisationJs/Permission.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports